import React from "react";

interface PaginationProps {
  total: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rows: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ total, page, rowsPerPage, onPageChange, onRowsPerPageChange }) => {
  const totalPages = Math.max(1, Math.ceil(total / rowsPerPage));
  const start = (page - 1) * rowsPerPage;
  const showing = total === 0 ? "Showing 0 - 0 of 0 results" : `Showing ${start + 1} - ${Math.min(start + rowsPerPage, total)} of ${total} results`;

  return (
    <div className="pagination-bar" id="pagination-bar">
      <span id="pg-showing">{showing}</span>
      <div className="pagination-controls">
        <label>
          Rows per Page:{" "}
          <select id="rows-per-page" value={rowsPerPage} onChange={(e) => onRowsPerPageChange(parseInt(e.target.value, 10))}>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </label>
        <button id="pg-prev" disabled={page <= 1} onClick={() => onPageChange(Math.max(1, page - 1))}>&laquo; Prev</button>
        <span id="pg-page-info">Page {page} of {totalPages}</span>
        <button id="pg-next" disabled={page >= totalPages} onClick={() => onPageChange(Math.min(totalPages, page + 1))}>Next &raquo;</button>
      </div>
    </div>
  );
};

export default Pagination;
